import React from "react";
import { RiMoneyPoundCircleFill } from "react-icons/ri"
import { BsFillCarFrontFill } from "react-icons/bs"
import { FaPlaneDeparture } from "react-icons/fa"

const aboutServices = [
    {
        id: 1,
        title: "Car Insurance",
        subtitle: "We provide Car Insurance Quote predictions for customers",
        icon: <RiMoneyPoundCircleFill/>,
        button_text: "Read More",
        link: "/compareonecar"
    },
    {
        id: 2,
        title: "Car Rental",
        subtitle: "We provide easy Car Rentals for fantastic daily & weekly rates",
        icon: <BsFillCarFrontFill/>,
        button_text: "Our Cars",
        link: "/browse"
    },
    {
        id: 3,
        title: "Airport Transfer",
        subtitle: "We provide Airport Transfers for next to no amount of money",
        icon: <FaPlaneDeparture/>,
        button_text: "More Info",
        link: "/about"
    }
]

export default aboutServices